'use client';

import { Tabs, Tab } from '@heroui/tabs';
import Image from 'next/image';
import LoanItem from './LoanItem';
import PartItem from './PartItem';
import { useMemo } from 'react';

const COS = 'http://feewee-1255997270.cos.ap-chengdu.myqcloud.com/static';
const remote = {
  CarSeriesBxk: `${COS}/mini/card/bxk.png`, // 保修卡
  CarSeriesByk: `${COS}/mini/card/byk.png`, // 保养卡
  CarSeriesBybxk: `${COS}/mini/card/bybxk.png`, // 保养保修卡
  CarSeriesBytck1: `${COS}/mini/card/bytck1.png`, // 保养套餐卡
  CarSeriesBytck2: `${COS}/mini/card/bytck2.png`, // 保养套餐卡
  CarSeriesBytck3: `${COS}/mini/card/bytck3.png`, // 保养套餐卡
};

const bytck = [`${COS}/mini/card/bytck1.png`, `${COS}/mini/card/bytck2.png`, `${COS}/mini/card/bytck3.png`];

export default function Index({ data }: { data?: CarDiscount.DiscountDetail }) {
  const defaultKey = useMemo(() => {
    if (data?.maintenanceWarrantyCardList?.length) {
      return '保养保修卡';
    }
    if (data?.lifetimeMaintainCardList?.length) {
      return '保养卡';
    }
    if (data?.warrantyCardList?.length) {
      return '保修卡';
    }
    if (data?.maintainCardList?.length) {
      return '保养套餐卡';
    }
  }, [data])
  return (
    <div className="flex w-full flex-col bg-white dark:bg-[#171717] mt-[10px]">
      <Tabs
        aria-label="Options"
        classNames={{
          tabList: 'gap-10 w-full relative rounded-none pl-[15px] pr-[15px] border-divider',
          cursor: 'w-full bg-[#ff921c]',
          tab: 'max-w-fit px-0 h-12',
          tabContent: 'group-data-[selected=true]:text-[#ff921c]',
        }}
        className="sticky top-0 bg-white dark:bg-[#171717]"
        color="primary"
        variant="underlined"
        defaultSelectedKey={defaultKey}
      >
        <Tab
          key="保养保修卡"
          title={
            <div className="flex items-center space-x-2">
              <span className='dark:text-white'>保养保修卡</span>
            </div>
          }
          hidden={!data?.maintenanceWarrantyCardList?.length}
        >
          {data?.maintenanceWarrantyCardList?.map((v, index) => (
            <div key={`bxk_${index}`} className="pl-[15px] pr-[15px] mb-[10px]">
              <div className={`flex flex-col`}>
                <div className="flex flex-col justify-center relative">
                  <Image sizes="100vw" width={375} height={100} alt="" style={{ width: '100%', height: 'auto' }} src={remote.CarSeriesBybxk} />
                  <div className="absolute pl-[15px] pr-[15px]">
                    <span className="text-lg text-[#E4D2AA] font-semibold">{v.name}</span>
                    <div>
                      <span className="text-sm text-[#fff]">零售价：{v.price}元</span>
                      <span className="text-[10px] text-[#927D4F] pl-[5px] line-through">市场价：{v.originalPrice}元</span>
                    </div>
                  </div>
                </div>
              </div>
              {v.carLoan && <LoanItem data={v.carLoan || []} />}
            </div>
          ))}
        </Tab>
        <Tab
          key="保养卡"
          title={
            <div className="flex items-center space-x-2">
              <span className='dark:text-white'>保养卡</span>
            </div>
          }
          hidden={!data?.lifetimeMaintainCardList?.length}
        >
          {data?.lifetimeMaintainCardList?.map((v,index) => (
            <div key={`byk_${index}`} className="pl-[15px] pr-[15px]">
              <div className={`flex flex-col`}>
                <div className="flex flex-col justify-center relative">
                  <Image sizes="100vw" width={375} height={100} alt="" style={{ width: '100%', height: 'auto' }} src={remote.CarSeriesByk} />
                  <div className="absolute pl-[15px] pr-[15px]">
                    <span className="text-lg text-[#E4D2AA] font-semibold">{v.name}</span>
                    <div>
                      <span className="text-sm text-[#fff]">零售价：{v.price}元</span>
                      <span className="text-[10px] text-[#927D4F] pl-[5px] line-through">市场价：{v.originalPrice}元</span>
                    </div>
                  </div>
                </div>
              </div>
              {v.carLoan && <LoanItem data={v.carLoan || []} />}
            </div>
          ))}
        </Tab>
        <Tab
          key="保修卡"
          title={
            <div className="flex items-center space-x-2">
              <span className='dark:text-white'>保修卡</span>
            </div>
          }
          hidden={!data?.warrantyCardList?.length}
        >
          {data?.warrantyCardList?.map((v, index) => (
            <div key={`bxk_${index}`} className="pl-[15px] pr-[15px]">
              <div className={`flex flex-col`}>
                <div className="flex flex-col justify-center relative">
                  <Image sizes="100vw" width={375} height={100} alt="" style={{ width: '100%', height: 'auto' }} src={remote.CarSeriesBxk} />
                  <div className="absolute pl-[15px] pr-[15px]">
                    <span className="text-lg text-[#E4D2AA] font-semibold">{v.name}</span>
                    <div>
                      <span className="text-sm text-[#fff]">零售价：{v.price}元</span>
                      <span className="text-[10px] text-[#927D4F] pl-[5px] line-through">市场价：{v.originalPrice}元</span>
                    </div>
                  </div>
                </div>
              </div>
              {v.carLoan && <LoanItem data={v.carLoan || []} />}
            </div>
          ))}
        </Tab>
        <Tab
          key="保养套餐卡"
          title={
            <div className="flex items-center space-x-2">
              <span className='dark:text-white'>保养套餐卡</span>
            </div>
          }
          hidden={!data?.maintainCardList?.length}
        >
          {data?.maintainCardLoanRule ? (
            <div className="pl-[15px] pr-[15px] mb-[10px]">
              <LoanItem ratio data={data.maintainCardLoanRule} />
            </div>
          ) : null}
          {data?.maintainCardList?.map((v,index) => (
            <div key={`bytck_${index}`} className="pl-[15px] pr-[15px]">
              <div className={`flex flex-col`}>
                <div className="flex flex-col justify-center relative">
                  <Image sizes="100vw" width={375} height={100} alt="" style={{ width: '100%', height: 'auto' }} src={bytck[index % 3]} />
                  <div className="absolute pl-[15px] pr-[15px]">
                    <span className="text-lg text-[#E4D2AA] font-semibold">{v.name}</span>
                    <div>
                      <span className="text-sm text-[#fff]">{v.validity}月</span>
                      <span className="text-lg text-[#fff] pl-[5px]">{v.times}</span>
                      <span className="text-sm text-[#fff]">次</span>
                    </div>
                  </div>
                </div>
                {v.cardEngineOilList?.length && <PartItem data={v.cardEngineOilList || []} />}
              </div>
            </div>
          ))}
        </Tab>
      </Tabs>
    </div>
  );
}
